module.exports = __webpack_public_path__ + "static/media/match.5830a946.svg";